import styled from 'styled-components'

import type { StyledCssProps } from '@subaio/components'
import { ButtonSubmit } from '@subaio/components/src/HookForm'

import { solidStyle } from '../Solid'

export const ButtonSolidSubmit = styled(ButtonSubmit)<StyledCssProps<typeof solidStyle>>`
	${solidStyle}
`
